import { request } from './request';
import { toast } from './toast';

export const dropdownFetch = async (dropdownName) => {
  if (!dropdownName) return [];
  const response = await request(`/${dropdownName}-dropdown`, { method: 'GET' });
  if (response?.success) {
    return response.data;
  } else {
    toast(`Failed to load ${dropdownName}`, { variant: 'error' });
    return [];
  }
};
